import { CSSProperties } from 'react';

export default function AddIcon({ s }: { s?: CSSProperties }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...s, verticalAlign: 'middle' }}
    >
      <g clipPath="url(#clip0_1911_3240)">
        <mask
          id="mask0_1911_3240"
          maskUnits="userSpaceOnUse"
          x="-6"
          y="-6"
          width="52"
          height="52"
        >
          <path
            d="M20.4048 -6L46 20.4048L19.5952 46L-6.00003 19.5952L20.4048 -6Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1911_3240)">
          <path
            d="M19.8594 27.1241C19.8587 27.0842 19.8587 27.0444 19.8593 27.0043L20.0785 12.9306L20.0802 12.8561"
            stroke="#1399D6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.3177 20.2126C27.2776 20.2131 27.2373 20.2131 27.1969 20.2124L13.0286 19.9918L12.9538 19.9901"
            stroke="#1399D6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          d="M20.8181 35.0843C24.3294 34.8953 27.791 33.4864 30.5141 30.8467C33.7814 27.6796 35.3109 23.3949 35.0842 19.1819"
          stroke="#250058"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.9157 20.8182C5.10466 24.3295 6.51362 27.7911 9.15325 30.5142C12.3204 33.7815 16.6051 35.311 20.8181 35.0843"
          stroke="#250058"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1819 4.91566C15.6706 5.10461 12.209 6.51357 9.4859 9.1532C6.21857 12.3204 4.68906 16.6051 4.91577 20.8181"
          stroke="#250058"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.0842 19.1818C34.8952 15.6705 33.4863 12.2089 30.8466 9.48581C27.6795 6.21848 23.3948 4.68896 19.1818 4.91568"
          stroke="#250058"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1911_3240">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
